import {useState, useEffect} from 'react';

export function useStripe() {
  const [stripe, setStripe] = useState(null);

  useEffect(() => {
    const key =
      process.env.NODE_ENV !== 'production' ||
      process.env.REACT_APP_IS_DEMO === '1'
        ? 'pk_test_SsaYtVBNjO05y3DGp66kkzrE'
        : 'pk_live_wcrsaOhPNWzrM8LTZJ0eumcW';

    function handleLoad() {
      setStripe(window.Stripe(key));
    }

    if (window.Stripe) {
      handleLoad();
      return;
    }

    const script = document.querySelector('#stripe-js');
    script.addEventListener('load', handleLoad);

    return () => script.removeEventListener('load', handleLoad);
  }, []);

  return stripe;
}
